import { rootApi } from "../../../services/rootApi";

export interface ITOUUrlRequest {
    email: string
    registrationId?: string
}

export interface IURlResult {
    url: string,
}

const jguApi = rootApi.injectEndpoints({
    overrideExisting: false,

    endpoints: builder => ({
        touUrl: builder.mutation<IURlResult, ITOUUrlRequest>({
            query: (request) => {
                return {
                    url: `/JGU/TOU-Url`,
                    method: 'POST',
                    body: request
                }
            },
        }),
        umsUrl: builder.mutation<IURlResult, ITOUUrlRequest>({
            query: (request) => {
                return {
                    url: `/JGU/UMS-Url`,
                    method: 'POST',
                    body: request
                }
            },
        }),
    })
})

export const {
    useTouUrlMutation,
    useUmsUrlMutation
} = jguApi;